import { Spinner } from "./style";

type SpinnerProps = {
  size: number;
};

const SpinnerLoading = ({ size }: SpinnerProps) => <Spinner size={size} />

export { SpinnerLoading };
